import React, { RefObject } from 'react';
import { KanbanCard } from '../../HBKanban.types';
import { useHBKanbanContext } from '../../HBKanbanContext';
import { StyledContentWrapper } from './HBKanbanCardContent.styles';

export const HBKanbanCardContent = <TItemData = any,>({
    card,
    isOverlay = false,
    isDragging = false,
    cardRef
}: {
    card: KanbanCard<TItemData>;
    isOverlay?: boolean;
    isDragging?: boolean;
    cardRef?: RefObject<HTMLDivElement>;
}) => {
    const { renderProps, isCardSelected, onToggleSelect, isInSelectableState } =
        useHBKanbanContext<TItemData>();

    const selected = onToggleSelect ? isCardSelected(card) : false;

    return (
        <StyledContentWrapper>
            {renderProps.renderCardContent?.(card, {
                isDragging,
                isOverlay,
                selected: onToggleSelect ? selected : undefined,
                onToggleSelect,
                isInSelectableState: onToggleSelect
                    ? isInSelectableState
                    : undefined,
                cardRef
            })}
        </StyledContentWrapper>
    );
};
